var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelosWordmarkWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 904.87 404.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: url(#linear-gradient);\n      }\n\n      .st1 {\n        fill: #fff;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 50.71,
    y1: 200.02,
    x2: 831.8,
    y2: 200.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#00adff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M203.58,240.4c0-53.07,40.86-93.23,94.63-93.23s94.63,40.16,94.63,93.23c0,4.19-.35,8.73-.7,12.57h-153.59c4.23,29.75,27.55,51.14,61.07,51.14,24.79,0,44.18-9.91,55.59-27.75h34.5c-13.97,34.22-48.54,57.27-90.44,57.27-54.82,0-95.68-40.15-95.68-93.23ZM238.54,226.08h120.04c-5.03-28.5-29.17-49.29-60.36-49.29s-53.98,20.12-59.68,49.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M417.75,119.82c13.08-.16,26.12,0,39.1.51v209.1h-39.1V119.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M480.51,240.4c0-53.07,40.85-93.23,95.32-93.23s95.32,40.16,95.32,93.23-41.2,93.23-95.32,93.23-95.32-40.15-95.32-93.23ZM628.86,240.4c0-30.4-22.63-53.7-53.03-53.7s-53.37,23.3-53.37,53.7,22.97,53.7,53.37,53.7,53.03-23.3,53.03-53.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M737.09,199.54c0-9.08,9.43-15.36,23.4-15.36,4.81,0,7.7.79,10.53,2.03-18.81-9.32-38.01-17.87-57.55-25.63-13.5,9.66-21.77,24.28-21.77,43.15,0,63.9,96.72,47.14,96.72,76.12,0,9.43-10.48,16.41-25.49,16.41-16.41,0-28.28-8.03-28.28-20.25h-45.74c0,33.52,29.68,57.62,74.03,57.62s71.23-23.39,71.23-58.31c0-63.9-97.07-47.49-97.07-75.77Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M818.21,155.36c-50.04-25.01-102.59-44.76-156.52-58.92-53.97-14.04-109.3-22.29-164.78-24.97-110.95-5.2-222.62,12.98-325.52,52.91-12.19,4.7-24.22,9.71-36.1,15.01,5.51-5.3,10.96-9.15,17.53-13.25v-24.02l-30.03,5.46v37.53c-22.67,10.61-44.78,22.29-66.37,35.05,0,0,0,0,.01,0-3.43,2.04-5.73,5.76-5.73,10.04,0,6.45,5.23,11.68,11.68,11.68,2.05,0,3.98-.53,5.66-1.46,18.02-9.88,36.22-18.91,54.75-27.18v103.8c0,33.17,20.25,52.37,56.21,52.37l17.26-.12,4.38-27.46h-17.46c-18.86,0-30.38-11.52-30.38-29.68v-111.51c9.27-3.65,18.64-7.13,28.12-10.43,100.53-35.22,208.07-48.96,313.59-40.5,52.73,4.31,104.92,13.88,155.45,28.83,50.5,15.06,99.33,35.32,145.51,60.33l.14.08c.21.11.41.22.63.32,12.13,6.06,26.88,1.14,32.94-10.99,6.06-12.13,1.14-26.88-10.99-32.94Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 807.34,
    cy: 177.39,
    r: 24.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelosWordmarkWhite);
export default __webpack_public_path__ + "static/media/telos-wordmark-white.5c0ecf1c0108517c020cd7dbefcc2dfe.svg";
export { ForwardRef as ReactComponent };